const PHONE_MIN_DIGITS = 7;
const PHONE_MAX_DIGITS = 15;

const EXTENSION_PATTERN = /(ext\.?|extension|x)\s*\d+\s*$/i;

export const normalizeEmail = (value) => {
  if (typeof value !== "string") {
    return "";
  }

  return value.trim().toLowerCase();
};

export const normalizePhoneForStorage = (value) => {
  if (typeof value !== "string") {
    return "";
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return "";
  }

  const withoutExtension = trimmed.replace(EXTENSION_PATTERN, "");
  const hasLeadingPlus = /^\s*\+/.test(withoutExtension);
  const digitsOnly = withoutExtension.replace(/\D/g, "");

  if (!digitsOnly) {
    return "";
  }

  return hasLeadingPlus ? `+${digitsOnly}` : digitsOnly;
};

export const getPhoneDigits = (value) => normalizePhoneForStorage(value).replace(/\D/g, "");

export const isPhoneDigitLengthValid = (value, minDigits = PHONE_MIN_DIGITS, maxDigits = PHONE_MAX_DIGITS) => {
  const digits = getPhoneDigits(value);
  if (!digits) {
    return false;
  }

  return digits.length >= minDigits && digits.length <= maxDigits;
};

export const formatPhoneForDisplay = (value) => {
  const normalized = normalizePhoneForStorage(value);
  if (!normalized) {
    return "";
  }

  const digits = normalized.replace(/\D/g, "");
  if (digits.length < 7) {
    return normalized;
  }

  if (digits.length === 7) {
    return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  }

  if (digits.length === 10) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  const countryCode = digits.slice(0, digits.length - 10);
  const local = digits.slice(-10);
  const localFormatted = `${local.slice(0, 3)}-${local.slice(3, 6)}-${local.slice(6)}`;

  if (!countryCode) {
    return localFormatted;
  }

  return `+${countryCode} ${localFormatted}`;
};

export const PHONE_DIGIT_RANGE = {
  min: PHONE_MIN_DIGITS,
  max: PHONE_MAX_DIGITS,
};
